import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ProfileLayout from "src/app/layouts/ProfileLayout";
import { AppRoutes } from "src/app/navigation/routes";
import { useAppSelector } from "src/app/services/store";
import { APP_MESSAGES } from "src/shared/config/src/lib/constants";
import { getCurrentChild } from "src/shared/redux-state/src";
import { fetchCommunicationMessage } from "src/shared/services/src";
import { ChildrenStoreData, CommunicationDetailResponseType } from "src/shared/types/src";
import MessageDetailCard from "./components/MessageDetailCard";
import MessageAttachments from "./components/MessageAttachment";
import { transformAttachmentTypeToMessageAttachmentPropType } from "src/shared/utils/src";
import { CustomButton, MessageDetailsLoader } from "src/app/components";
import LocalImages from "../../static";
import { checkIsEylogOnlyNursery } from "src/app/utilities/helpers";

export default function CommunicationDetails() {
    const { communicationId } = useParams();
    const [message, setMessage] = useState<CommunicationDetailResponseType | undefined>();
    const [isFetchingMessage, setIsFetchingMessage] = useState(true);
    const [isApiError, setApiError] = useState<boolean>(false);
    const [apiErrorMsg, setApiErrorMsg] = useState(APP_MESSAGES.generalErrorMessage);
    const navigate = useNavigate();

    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);

    useEffect(() => {
        if (checkIsEylogOnlyNursery(currentChild)) {
            navigate(AppRoutes.EYLOG_MESSAGES);
        };
    }, [currentChild.childInstanceKey]);

    const init = async () => {
        setIsFetchingMessage(true);
        try {
            const response = await fetchCommunicationMessage(currentChild.instanceUrl, currentChild.nursery.eymanNurseryId, Number(communicationId));
            const messageResponse = response.message as CommunicationDetailResponseType;
            if (messageResponse) {
                setMessage(messageResponse);
            } else {
                setApiError(true);
                setApiErrorMsg(APP_MESSAGES.generalErrorMessage);
            }
        } catch (error) {
            setApiError(true);
            setApiErrorMsg(APP_MESSAGES.generalErrorMessage);
        } finally {
            setIsFetchingMessage(false);
        }
    };

    useEffect(() => {
        init();
    }, []);

    useEffect(() => {
        if (isApiError && apiErrorMsg) {
            toast.error(apiErrorMsg, {
                onClose: () => setApiError(false)
            });
        }
    }, [isApiError, apiErrorMsg])

    const onReplyButtonPress = () => {
        navigate(`${AppRoutes.COMMUNICATIONS}/${communicationId}${AppRoutes.REPLY}`);
    }

    const _renderDetail = () => {
        return (
            <>
                {message && <MessageDetailCard message={message} />}
                {(!!message?.attachments && message.attachments?.length > 0) && <div><MessageAttachments
                    attachments={message.attachments.map((item) => transformAttachmentTypeToMessageAttachmentPropType(item))}
                /></div>}
            </>
        )
    }

    const NoMessages = () => {
        return (
            <div className='no-data-found message'>
                <img src={LocalImages.noMessageFound} alt="no-message" />
                <p className='text-center fs-16 fw-bold text-black mg-b-0 mg-t-10'>
                    No data available
                </p>
            </div>
        );
    }

    return (
        <ProfileLayout title={"Communication Details"} fixedFooter={true} showProfileImage={false}>
            <div>
                <div>
                    {isFetchingMessage ? <div>
                        <MessageDetailsLoader />
                    </div> : (
                        (message && Object.keys(message).length > 0) ? _renderDetail() :
                            <NoMessages />
                    )}
                </div>
                {/* { message?.canReply && <CustomButton color="primary" onClick={onReplyButtonPress} text="Reply" customBtnStyle="mg-t-20" />} */}

                { message?.canReply && <div className="section-fixed pd-b-10 pd-x-20">
                    <CustomButton color="primary" onClick={onReplyButtonPress} text="Reply" />
                </div> }
            </div>
        </ProfileLayout>
    );
}